// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
    This file handle common CSS property for custom interface list view template
*/
.container-list-component {
  padding-right: 0;
}

.list-col-text {
  padding-left: 0;
}

.list-col-value {
  text-align: right;
  padding-right: 0;
}

.center-vertically-horizzontally {
  text-align: center;
}

.container-keypad {
  margin: 0 auto;
}

.container-icon-keypdad {
  position: relative;
}

i {
  font-size: 25px;
  position: absolute;
  right: 0;
  top: 5px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/theme/supervision-list-common.scss","webpack://./src/components/template%20component/virtual-access-template/virtual-access-template.component.scss","webpack://./src/components/template component/virtual-access-template/virtual-access-template.component.scss"],"names":[],"mappings":"AAAA;;CAAA;AAIA;EACI,gBAAA;ACAJ;;ADGA;EACI,eAAA;ACAJ;;ADGA;EACI,iBAAA;EACA,gBAAA;ACAJ;;ADGA;EACI,kBAAA;ACAJ;;AChBA;EACI,cAAA;ADmBJ;;AChBA;EACI,kBAAA;ADmBJ;;AChBA;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,eAAA;ADmBJ","sourcesContent":["/**\n    This file handle common CSS property for custom interface list view template\n*/\n\n.container-list-component {\n    padding-right: 0;\n}\n\n.list-col-text{\n    padding-left: 0;\n}\n\n.list-col-value{\n    text-align: right; \n    padding-right: 0;\n} \n\n.center-vertically-horizzontally{\n    text-align: center;\n}","/**\n    This file handle common CSS property for custom interface list view template\n*/\n.container-list-component {\n  padding-right: 0;\n}\n\n.list-col-text {\n  padding-left: 0;\n}\n\n.list-col-value {\n  text-align: right;\n  padding-right: 0;\n}\n\n.center-vertically-horizzontally {\n  text-align: center;\n}\n\n.container-keypad {\n  margin: 0 auto;\n}\n\n.container-icon-keypdad {\n  position: relative;\n}\n\ni {\n  font-size: 25px;\n  position: absolute;\n  right: 0;\n  top: 5px;\n  cursor: pointer;\n}","@use '../../../theme/supervision-list-common.scss';\n\n.container-keypad {\n    margin: 0 auto;\n}\n\n.container-icon-keypdad{\n    position: relative;\n}\n\ni {\n    font-size: 25px;\n    position: absolute;\n    right: 0;\n    top: 5px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
